/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetProjectChangeOrdersDetailsQuery } from '../../models/get-project-change-orders-details-query';
import { GetProjectChangeOrdersDetailsQueryResult } from '../../models/get-project-change-orders-details-query-result';

export interface ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Params {
      body?: GetProjectChangeOrdersDetailsQuery
}

export function apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain(http: HttpClient, rootUrl: string, params?: ApiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetProjectChangeOrdersDetailsQueryResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetProjectChangeOrdersDetailsQueryResult>;
    })
  );
}

apiProjectChangeOrderGetProjectChangeOrdersDetailsPost$Plain.PATH = '/api/ProjectChangeOrder/GetProjectChangeOrdersDetails';
